import { Col, Form, Row } from "antd";
import React from "react";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import Selects from "../../../../biblio/Selects/Selects";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  addRequest,
  getAllSponsorRequests,
} from "../../../../apis/actions/sponsor.actions";
import { showNotitfication } from "../../../../components/utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { setResModel ,setResIds } from "../../../../apis/slices/ratingSlice";
interface Props {
  requestsTypes: any;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}
const AddSponsorRequest = ({ requestsTypes, setIsModalVisible }: Props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [value, setValue] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const OtpId =  useSelector(
    (state: RootState) => state?.recipient?.OtpId
  )
  const onFinish = async () => {
    try {
      await form.validateFields();
      setIsSubmitting(true);

      const FormValues = form.getFieldsValue();
      FormValues.details = value;
      const requestType = form.getFieldValue("request_type_id");
      let requestsFormData = {
        ...FormValues,
        request_type_id: requestType?.value,
        sponsor_id: OtpId,
      };
      dispatch(addRequest(requestsFormData)).then((result: any) => {
        const request = result?.payload?.data?.result;
        if (request?.code === 200) {
          dispatch(setResModel(request?.res_model));
          dispatch(setResIds([request?.request_id]))
          showNotitfication(
            `${request?.message} - رقم الطلب: ${request?.request_number}`,
            "success",dispatch
          );
          form.resetFields();
          setIsModalVisible(false);
          dispatch(getAllSponsorRequests({ sponsor_id: OtpId }));
        } else {
          showNotitfication(request?.message, "error");
          setIsModalVisible(false);
        }
        setIsSubmitting(false);
      });
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
    }
  };

  const onChange = (value: any) => {
    setValue(value);
  };
  return (
    <Form form={form} layout="vertical">
      <Row justify={"center"}>
        <p className="takaful--confirm-logout">إنشاء طلب الكافل </p>
      </Row>
      <Row
        gutter={16}
        justify={"center"}
        style={{ paddingTop: "2rem" }}
        className={`takaful--content-profile-box1 takaful--content-select`}
      >
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={7}
          xs={7}
          className="takaful--content-profile-col "
        >
          <p
            style={{ lineHeight: "2.5" }}
            className="takaful--content-services-request-p"
          >
            نوع الطلب :
          </p>
        </Col>
        <Col
          xxl={19}
          xl={19}
          lg={19}
          md={19}
          sm={17}
          xs={17}
          className="takaful--content-profile-col"
        >
          <Form.Item
            name="request_type_id"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <Selects
              options={requestsTypes}
              selectPlaceholder="نوع الطلب"
              allowClear={true}
              className="takaful--service-select"
              popupClassName="takaful--service-select-dropdown"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row
        gutter={16}
        justify={"center"}
        className={`takaful--content-profile-box1`}
      >
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={5}
          xs={24}
          className="takaful--content-profile-col"
        >
          <p className="takaful--content-services-request-p">تفاصيل الطلب :</p>
        </Col>
        <Col
          xxl={19}
          xl={19}
          lg={19}
          md={19}
          sm={19}
          xs={24}
          className="takaful--content-profile-col"
        >
          <Form.Item
            name="details"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
          >
            <ReactQuill
              style={{ padding: "0 11px" }}
              onChange={onChange}
              modules={{
                toolbar: [
                  ["bold", "italic", "underline", "strike"],
                  [{ header: [1, 2, 3, 4, 5, 6, false] }],
                  [{ color: [] }],
                  [{ list: "ordered" }, { list: "bullet" }],
                  [{ align: [] }],
                  ["clean"],
                ],
              }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row justify={"end"} dir="rtl" style={{ width: "100%" }}>
        <Col xxl={4} xl={4} lg={4} md={4} sm={9} xs={9}>
          <PrimaryButton
            disabled={isSubmitting}
            loading={isSubmitting}
            style={{ width: "100%" }}
            onClick={() => {
              onFinish();
            }}
            title=" إرسال  "
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AddSponsorRequest;
